import ExpandableSection from "../component/_expandableSection";
import Swiper from 'swiper';
import { Autoplay, Pagination } from 'swiper/modules'
document.addEventListener('DOMContentLoaded', function() {
    new ExpandableSection('.js-css-filter-group-main', '.js-css-filter-group-title-wrapper', '.js-css-list-wrapper', '.js-css-title-chevron', false, true, false, false);

    const swiperContainer = document.querySelector('.js-css-more-swiper');

    if(swiperContainer) {
        var swiper = new Swiper('.js-css-more-swiper', {
            modules: [Autoplay, Pagination],
            slidesPerView: 1,
            spaceBetween: 20,
            loop: true,
            autoplay: {
                delay: 6000,
            },
            pagination: {
                el: '.js-css-swiper-navigation',
                clickable: true,
            },
            breakpoints: {
                768: {
                    slidesPerView: 2,
                },
                1024: {
                    slidesPerView: 3,
                },
            },
        });
    }

    const filterElement = document.querySelector('.js-css-single-filter');
    const sidebarElement = document.querySelector('.js-css-single-sidebar');
    const filterWrapper = document.querySelector('.js-css-more-filter-wrapper');

    if (filterElement || sidebarElement || filterWrapper) {
        const moveFilterElement = () => {
            const viewportWidth = window.innerWidth;

            if (viewportWidth > 991) {
                // Move the filter element to the sidebar on desktop
                if (!sidebarElement.contains(filterElement)) {
                    sidebarElement.appendChild(filterElement);
                }
            } else {
                // Move the filter element back to the original wrapper on smaller screens
                if (!filterWrapper.contains(filterElement)) {
                    filterWrapper.appendChild(filterElement);
                }
            }
        };

        // Move the filter element initially based on the current screen size
        moveFilterElement();

        // Add event listener for screen resizing to move the filter element accordingly
        window.addEventListener('resize', moveFilterElement);
    }
});

